export default __webpack_public_path__ + "static/media/ml.22fd5309.jpg";